<form [formGroup]="form" (submit)="onSubmit()">
  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Primeiro nome</mat-label>
      <input
        matInput
        type="text"
        placeholder="Informe seu primeiro nome"
        formControlName="firstname"
      />
      <mat-error *ngIf="form.get('firstname').errors?.required"
        >Por favor informe o nome</mat-error
      >
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Sobrenome</mat-label>
      <input
        matInput
        type="text"
        placeholder="Informe seu sobrenome"
        formControlName="lastname"
      />
      <mat-error *ngIf="form.get('lastname').errors?.required"
        >Por favor informe o sobrenome</mat-error
      >
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Email</mat-label>
      <input
        matInput
        type="email"
        placeholder="Informe seu email"
        formControlName="email"
        (blur)="checkEmailValidity()"
      />
      <mat-error *ngIf="form.get('email').errors?.alread"
        >Esse email já esta sendo usado por outra conta</mat-error
      >
      <mat-error *ngIf="form.get('email').errors?.required"
        >Por favor informe o email</mat-error
      >
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>CPF</mat-label>
      <input
        matInput
        type="text"
        placeholder="Informe seu cpf"
        mask="000.000.000-00"
        formControlName="cpf"
        inputmode="numeric"
      />
      <mat-error *ngIf="form.get('cpf').errors?.alread"
        >Esse cpf já esta sendo usado por outra conta</mat-error
      >
      <mat-error *ngIf="form.get('cpf').errors?.required"
        >Por favor informe o CPF</mat-error
      >
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Celular</mat-label>
      <input
        matInput
        type="phone"
        placeholder="Informe seu numero de telefone"
        mask="(00) 00000 0000"
        formControlName="phone"
        inputmode="numeric"
      />
      <mat-error *ngIf="form.get('phone').errors?.alread"
        >Esse numero já esta sendo usado por outra conta</mat-error
      >
      <mat-error *ngIf="form.get('phone').errors?.required"
        >Por favor informe o telefone</mat-error
      >
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Whatsapp</mat-label>
      <input
        matInput
        type="phone"
        placeholder="Informe seu numero de whatsapp"
        mask="(00) 00000 0000"
        formControlName="mobile"
        inputmode="numeric"
      />
      <mat-error *ngIf="form.get('mobile').errors?.alread"
        >Esse numero já esta sendo usado por outra conta</mat-error
      >
      <mat-error *ngIf="form.get('mobile').errors?.required"
        >Por favor informe o numero de whatsapp</mat-error
      >
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Senha</mat-label>
      <input
        matInput
        [type]="showPassword ? 'text' : 'password'"
        placeholder="Informe sua senha"
        formControlName="password"
      />
      <mat-icon matSuffix (click)="showPassword = !showPassword">{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      <mat-error *ngIf="form.get('password').errors?.required"
        >Por favor informe a senha</mat-error
      >
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Confirmar senha</mat-label>
      <input
        matInput
        [type]="showPassword ? 'text' : 'password'"
        placeholder="Repita sua senha"
        formControlName="password2"
      />
      <!-- <mat-icon matSuffix (click)="showPassword = !showPassword">{{showPassword ? 'visibility_off' : 'visibility'}}</mat-icon> -->
      <mat-error *ngIf="form.get('password2').errors?.required"
        >Por favor informe a confirmação da senha</mat-error
      >
    </mat-form-field>

    <!-- <ng-container *ngIf="!(isSmallScreen$ | async)"> -->
    <!-- <ng-container class="col-sm-12">
      <button
        mat-icon-button
        color="primary"
        type="button"
        (click)="showPassword = !showPassword"
      >
        <mat-icon *ngIf="!showPassword">visibility</mat-icon>
        <mat-icon *ngIf="showPassword">visibility_off</mat-icon>
      </button>
    </ng-container> -->
  </div>

  <!-- <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Cargo desejado</mat-label>
        <mat-select 
            placeholder="Nome do cargo desejado"                
            matInput
            formControlName="vacancy">
            <mat-option *ngFor="let vacancy of allVacancies" [value]="vacancy.professional_name">
                {{ vacancy.professional_name }}
            </mat-option>
        </mat-select>
      <input
        type="text"
        placeholder="Nome do cargo desejado"
        matInput
        formControlName="desiredJobTitle"
        (blur)="onBlurInput('desiredJobTitle')"
        (focus)="onFocusInput('desiredJobTitle')"
        (keyup)="
          filteredDesirableJobs = _filterDesirableJobs($event.target.value)
        "
        [matAutocomplete]="auto"
      />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option
          *ngFor="let desirableJob of filteredDesirableJobs"
          [value]="desirableJob.Name"
        >
          {{ desirableJob.Name }}
        </mat-option>
        <mat-error *ngIf="form.get('desiredJobTitle').errors?.invalid"
          >Escolha um dos valores que aparecem na lista ao digitar</mat-error
        >
      </mat-autocomplete>
    </mat-form-field>
  </div> -->

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Cargo desejado</mat-label>
      <mat-chip-list #chipList>
        <mat-chip
          *ngFor="let job of form.get('desiredJobTitles').value"
          [removable]="true"
          (removed)="removeDesiredJob(job)"
        >
          {{ job }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>

      <input
        id="desiredJobTitle"
        *ngIf="form.get('desiredJobTitles').value.length < 3"
        type="text"
        placeholder="Nome do cargo desejado"
        matInput
        formControlName="desiredJobTitle"
        (blur)="onBlurInput('desiredJobTitle')"
        (keyup)="filterDesirableJobs($event.target.value)"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="addDesiredJob($event)"
      />

      <mat-autocomplete #auto (optionSelected)="onOptionSelected($event)">
        <mat-option
          *ngFor="let desirableJob of filteredDesirableJobs"
          [value]="desirableJob.Name"
        >
          {{ desirableJob.Name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        *ngIf="
          form.get('desiredJobTitle').hasError('invalid') &&
          form.get('desiredJobTitle').touched
        "
      >
        Valor inválido. Escolha uma opção válida.
      </mat-error>
      <mat-error *ngIf="form.get('desiredJobTitle').errors?.required"
        >Por favor informe um cargo</mat-error
      >
      <mat-error *ngIf="form.get('desiredJobTitle').hasError('required')">
        Cargo desejado é obrigatório
      </mat-error>
      <mat-hint *ngIf="form.get('desiredJobTitles').value.length === 3">
        3 cargos selecionados, limite máximo atingido.
      </mat-hint>
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="outline">
      <mat-label>Fale sobre você</mat-label>
      <textarea
        matInput
        placeholder="conte-nos um pouco mais sobre você e seus objetivos"
        formControlName="aboutme"
        rows="10"
        maxlength="1000"
      ></textarea>
      <mat-hint>Informe até 1000 caracteres</mat-hint>
      <mat-error *ngIf="form.get('aboutme').errors?.required"
        >Por favor preencher o campo</mat-error
      >
      <mat-error *ngIf="form.get('aboutme').errors?.maxlength"
        >Por favor informe no máximo 1000 caracteres</mat-error
      >
    </mat-form-field>
  </div>

  <div class="row" style="margin-top: 10px">
    <mat-checkbox color="primary" formControlName="acceptTerm" required>
      Aceito os termos de uso da plataforma
      <a [attr.href]="LinkTermos" target="_blank">(ler termo de uso)</a>
    </mat-checkbox>
  </div>
  <div class="row">
    <mat-error *ngIf="!form.get('acceptTerm').value">
      É necessário aceitar os termos de uso
    </mat-error>
  </div>
  <div class="row">
    <mat-checkbox color="primary" formControlName="acceptContract" required>
      Aceito o contrato da plataforma
      <a [attr.href]="LinkContrato" target="_blank">(ler contrato)</a>
    </mat-checkbox>
  </div>
  <div class="row">
    <mat-error *ngIf="!form.get('acceptContract').value">
      É necessário aceitar o contrato
    </mat-error>
  </div>

  <div class="actions">
    <button
      mat-raised-button
      class="custom-primary"
      color="primary"
      type="submit"
      [disabled]="!form.valid"
      matStepperNext
    >
      Continuar
    </button>
  </div>
</form>
<iframe
  *ngIf="mauticFormSrc"
  [src]="mauticFormSrc"
  hidden
  frameborder="0"
></iframe>

<iframe
  *ngIf="mauticFormSrc2"
  [src]="mauticFormSrc2"
  hidden
  frameborder="0"
></iframe>
